"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../../../types/facts/Facts");
const Facts_2 = require("../../../types/sports/rugbyLeague/Facts");
exports.rugbyLeagueFacts = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Facts_2.RugbyLeagueSpecificFact), Facts_1.SubstitutionFact), Facts_1.BreakFact), Facts_1.PeriodFact), Facts_1.ClockFact);
exports.rugbyLeagueFactNameMap = {
    TRY: 'try',
    GOAL_KICK_SCORED: 'conversion',
    GOAL_KICK_MISSED: 'missed conversion',
    PENALTY_GOAL: 'penalty goal',
    DROP_GOAL: 'drop goal'
};
exports.rugbyLeagueStatKeyToNameMap = {
    tries: 'Tries',
    points: 'Points',
    conversions: 'Conversions',
    missedConversions: 'Missed Conversions',
    penaltyGoals: 'Penalty Goals',
    dropGoals: 'Drop Goals'
};
// tslint:disable-next-line variable-name
exports.RugbyLeagueFactStatMap = {
    [Facts_2.RugbyLeagueSpecificFact.TRY]: 'tries',
    [Facts_2.RugbyLeagueSpecificFact.GOAL_KICK_SCORED]: 'conversions',
    [Facts_2.RugbyLeagueSpecificFact.GOAL_KICK_MISSED]: 'missedConversions',
    [Facts_2.RugbyLeagueSpecificFact.PENALTY_GOAL]: 'penaltyGoals',
    [Facts_2.RugbyLeagueSpecificFact.DROP_GOAL]: 'dropGoals'
};
//# sourceMappingURL=Facts.js.map